import { get } from "lodash";

export const getContractors = state => {
  return get(state, "pageContent.contractors", []);
};

export const getContractorAssignments = state => {
  return get(state, "pageContent.contractor_assignments", []);
};
